import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";
import {Formatter} from "@/core/services/formatter.service";

export default class TemporaryItemsApproveModel extends BaseModel {
  uuids = null;
  customer = {}
  receipt_uuid = {}
  receipt_no = null;
  date = Formatter.getNowAsDate();
  department_uuid = null;
  description = null;
  message = null;
  miscellaneous_items = [];
  specialists_uuids = [];

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    receipt_no: 'max:10',
    date: 'required'
  };

  attributeHints = {
    receipt_no: i18n.t('If you leave this blank it will be automatically generated'),
    receipt_uuid: i18n.t('If you leave this blank it will be automatically generated'),
  };

  attributeLabels = {
    receipt_no: i18n.t('Receipt'),
    receipt_uuid: i18n.t('Receipt'),
    uuid: i18n.t('UUID'),
    customer_uuid: i18n.t('Customer'),
    date: i18n.t('Date'),
    recommended_by_uuid: i18n.t('Recommended By'),
    department_uuid: i18n.t('Department'),
    specialists_uuids: i18n.t('Specialists'),
    description: i18n.t('Description'),
    message: i18n.t('Message'),
  };
}
